import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import Print from '../src/utlis/print.js'
import QRCode from 'qrcode'
import JsBarcode from 'jsbarcode';
import md5 from 'js-md5';
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
Vue.use(Print);
import "./css/reset.css";
import "./css/theme.scss";
import "./css/common.css";

import './utlis/directive' //自定义指令
import { ceil, ceilYen, formatNumber } from './utlis/utlis'
import { ossUp, createClient } from './utlis/aliOss.js'
import config from './api/config'

import baseBreadcrumb from './components/common/baseBreadcrumb' // 面包屑
import getNotice from './components/common/getNotice' // 注意事项
import cascader from './components/common/cascader' // 组织选择
import attributeName from './components/common/attributeName'
import optionServiceRemark from './components/common/optionServiceRemark'
import echarts from './components/echarts/echarts'// echarts
import attributeSpeech from './components/common/attributeSpeech'


Vue.component('baseBreadcrumb', baseBreadcrumb)
Vue.component('cascader', cascader)
Vue.component('getNotice', getNotice)//注意事项
Vue.component('attributeName', attributeName)//客户属性
Vue.component('optionServiceRemark', optionServiceRemark)//服务单明细备注
Vue.component('attributeSpeech', attributeSpeech)//客户属性语音播报
Vue.component('echarts', echarts)//echarts
// API挂到vue原型下
import api from './api/apis'
Vue.prototype.$api = api
Vue.prototype.baseURL = config.baseURL
Vue.prototype.ceil = ceil
Vue.prototype.ceilYen = ceilYen
Vue.prototype.$md5 = md5;
Vue.prototype.$JsBarcode = JsBarcode //一维码
Vue.prototype.$QRCode = QRCode  //二维码
Vue.prototype.createClient = createClient  //oss 创建实例
Vue.prototype.ossUp = ossUp  //oss上传
Vue.prototype.formatNumber = formatNumber  //千分位
Vue.prototype.isRelease = location.host.indexOf('.com') === -1  // 是否发布
import VueI18n from 'vue-i18n' //引入vue-i18n
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入Element UI的中文包
import jaLocale from 'element-ui/lib/locale/lang/ja' //引入Element UI的日文包
import {
  isAuth, copy
} from './utlis/auth'
// Vue.use(ElementUI);
Vue.use(VueI18n)

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'zh', // 语言标识

  messages: {
    zh: Object.assign(require('./utlis/multilingual/zh'), zhLocale), //这里需要注意一下，是如何导入多个语言包的
    ja: Object.assign(require('./utlis/multilingual/ja'), jaLocale),
  }
});
Vue.prototype.isAuth = isAuth //权限函数挂载
Vue.prototype.copy = copy //拷贝挂载

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue(); // event Bus 用于无关系组件间的通信。
import Zdialog from './components/dialog/Dialog.vue'
//注册为全局组件
Vue.component('zDialog', Zdialog)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
